var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"my-modal",attrs:{"okTitle":"OK","cancelTitle":"Cancel"},on:{"ok":_vm.emitOkEvent,"cancel":_vm.emitCancelEvent}},[_vm._v(" "+_vm._s(_vm.message)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }